import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { formatDate, formatAmountZhCn } from "../../utils";
import OutMoneyPlan from "./indexOutMoneyPlan";
import { OutMoneyPlanProps } from "./indexOutMoneyPlan";

import { IconModalStroked } from "@douyinfe/semi-icons";
import { Modal, Typography, Descriptions } from "@douyinfe/semi-ui";
import React, { useEffect, useMemo, useState } from "react";
import { ApiClient } from "../../api/ApiClient";
let apiClient = ApiClient.getDefault();

export default function statOutMoneyPlanLead() {
  const [detailShow, setDetailShow] = useState(false);
  const [outMoneyPlanProps, setOutMoneyPlanProps] = useState(
    undefined as undefined | OutMoneyPlanProps,
  );
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [summaryData, setSummaryData] = useState<any>(null);

  const computeSummary = (data: any[]) => {
    const parentNodes = data.filter((row: any) => row.children && row.children.length > 0);
    const nodesToSum = parentNodes.length > 0 ? parentNodes : data;
    const fields = ['capitalScaleAmount', 'creditHelpRepaymentPlanAmount',
      'loanHelpRepaymentPlanAmount', 'cardHelpRepaymentPlanAmount', 'postingHelpAmount',
      'borrowAmount', 'borrowReturnAmount', 'paidAmount'];
    const summary: any = {};
    fields.forEach(field => {
      summary[field] = nodesToSum.reduce((sum: number, row: any) => sum + (row[field] || 0), 0);
    });
    return summary;
  };
  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      hideInEdit: true,
      hideInCreate: true,
      hideInList: true,
      type: ColType.NUMBER,
    },
    {
      name: "客户ID",
      key: "leadId",
      hideInList: true,
      showInFilter: true,
      type: ColType.STRING,
    },
   
    {
      name: "城市",
      key: "leadCity",
      width: 60,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
      hideInEdit: true,
      hideInCreate: true,
      hideInList: true,
      showInFilter: true,
    },
    {
      name: "平台",
      key: "platform",
      hideInList: true,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "出款人ID",
      key: "outMoneyUserId",
      hideInList: true,
      showInFilter: false,
      type: ColType.STRING,
    },

      {
      name: "客户姓名",
      key: "leadName",
      hideInList: false,
      width: 100,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
         if(record.outMoneyUserId){
        return "--";
      } else {
        return (
          <Typography.Text
            link
            onClick={() => {
              openOutMoneyPlanModal(null, record.leadId);
            }}
          >
            {value}
          </Typography.Text>
        );
      }
      },
    },
    {
      name: "出款人",
      key: "outMoneyUserName",
      showInFilter: true,
      width: 120,
      type: ColType.STRING,
      render: (value, record, index) => {
        if(!value){
          return '--';
        }
        return (
          <Typography.Text
            link
            onClick={() => {
              openOutMoneyPlanModal(record.outMoneyUserId,record.leadId);
            }}
          >
            {value}
          </Typography.Text>
        );
 
      },
    },
   

    {
      name: "资金规模",
      key: "capitalScaleAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a, row) => formatAmountZhCn(row.capitalScaleAmount),
    },
    {
      name: "总出款金额",
      key: "amount",
      width: 90,
      type: ColType.NUMBER,
      render: (a, row) =>
        formatAmountZhCn(row.creditHelpRepaymentPlanAmount + row.borrowAmount),
    },
    {
      name: "总代还金额",
      key: "creditHelpRepaymentPlanAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "贷款代还金额",
      key: "loanHelpRepaymentPlanAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "信用卡代还金额",
      key: "cardHelpRepaymentPlanAmount",
      width: 100,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "过账代还金额",
      key: "postingHelpAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "借出金额",
      key: "borrowAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "借出归还金额",
      key: "borrowReturnAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "支出金额",
      key: "paidAmount",
      width: 90,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
  ];
  const openOutMoneyPlanModal = async (outMoneyUserId: number, leadId?: number) => {
    console.log("openOutMoneyPlanModal ", outMoneyUserId, leadId);
    let queryParams = crudApi?.getQueryParams();
    let p: OutMoneyPlanProps = {
      
      ...queryParams,
      outMoneyUserId: outMoneyUserId,
      leadId: leadId,
    };
    setOutMoneyPlanProps(p);
    setDetailShow(true);
  };

  return (
    <>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title={"出款明细"}
        fullScreen={true}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        footer={null}
        hasCancel={false}
        onCancel={() => setDetailShow(false)}
        onOk={() => setDetailShow(false)}
        visible={detailShow}
      >
        <div>
          <OutMoneyPlan
            leadId={outMoneyPlanProps?.leadId}
            leadName={outMoneyPlanProps?.leadName}
            outMoneyUserId={outMoneyPlanProps?.outMoneyUserId}
            leadCity={outMoneyPlanProps?.leadCity}
            platform={outMoneyPlanProps?.platform}
          />
        </div>
      </Modal>
      {summaryData && (
        <Descriptions
          data={[
            { key: "汇总", value: "" },
            { key: "资金规模", value: formatAmountZhCn(summaryData.capitalScaleAmount) },
            { key: "总出款金额", value: formatAmountZhCn(summaryData.creditHelpRepaymentPlanAmount + summaryData.borrowAmount) },
            { key: "总代还金额", value: formatAmountZhCn(summaryData.creditHelpRepaymentPlanAmount) },
            { key: "贷款代还", value: formatAmountZhCn(summaryData.loanHelpRepaymentPlanAmount) },
            { key: "信用卡代还", value: formatAmountZhCn(summaryData.cardHelpRepaymentPlanAmount) },
            { key: "过账代还", value: formatAmountZhCn(summaryData.postingHelpAmount) },
            { key: "借出金额", value: formatAmountZhCn(summaryData.borrowAmount) },
            { key: "借出归还", value: formatAmountZhCn(summaryData.borrowReturnAmount) },
            { key: "支出金额", value: formatAmountZhCn(summaryData.paidAmount) },
          ]}
          row
          style={{
            boxShadow: "var(--semi-shadow-elevated)",
            backgroundColor: "var(--semi-color-bg-2)",
            borderRadius: 4,
            padding: 10,
            margin: '8px 0',
          }}
        />
      )}
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
          const data = crudApi.getData();
          if (data && data.length > 0) {
            setSummaryData(computeSummary(data));
          } else {
            setSummaryData(null);
          }
        }}
        canUpdate={false}
        canCreate={false}
        bordered={true}
        rowActionWidth={60}
        name="出款金额统计"
        entityKey="repaymentPlan/statPaidPlanByOutMoneyLeadId"
        pageSize={500}
        cols={cols}
      />
    </>
  );
}
